import { render, staticRenderFns } from "./Sketches.vue?vue&type=template&id=da40e8f0&scoped=true"
import script from "./Sketches.vue?vue&type=script&lang=js"
export * from "./Sketches.vue?vue&type=script&lang=js"
import style0 from "./Sketches.vue?vue&type=style&index=0&id=da40e8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40e8f0",
  null
  
)

export default component.exports